import { openModal } from '@vario-connect/frontend-design';

// „Ungespeicherte Änderungen"-Marker für die Detail-Tabs des Artikel-Lister-Slots.
//
// Hintergrund: Manche Tabs (Zusatzfelder, Varianten) werden bei JEDER Aktivierung neu
// gerendert. Schaltet der Händler mit ungespeicherten Eingaben weg und wieder zurück,
// sind die Eingaben weg. Der Tab-Wechsel-Guard (listing-detail-pane) warnt deshalb vor
// dem Verlassen eines „dirty" markierten Tabs.
//
// Der Marker lebt als `data-dirty="1"` am jeweiligen Tab-Pane (`[data-detail-pane]`).
// Dieselbe Datei stellt zusaetzlich den GEMEINSAMEN Bestaetigungsdialog bereit
// (`confirmDiscardChanges`), den auch die Einstellungen beim Abschnittswechsel nutzen —
// damit die Warnung ueberall identisch aussieht und formuliert ist. Kein Browser-Dialog.
// Editierbare Tab-Module rufen markTabDirty() bei einer Eingabe und clearTabDirty() nach
// erfolgreichem Speichern/Zurücksetzen — jeweils mit einem Element AUS ihrem Pane; der
// Helper löst den umgebenden Pane selbst auf.

function paneOf(el: HTMLElement): HTMLElement | null {
  return el.closest<HTMLElement>('[data-detail-pane]');
}

/** Markiert den Tab, der `el` enthält, als „ungespeichert". */
export function markTabDirty(el: HTMLElement): void {
  const pane = paneOf(el);
  if (pane) pane.dataset['dirty'] = '1';
}

/** Löscht den „ungespeichert"-Marker des Tabs, der `el` enthält. */
export function clearTabDirty(el: HTMLElement): void {
  const pane = paneOf(el);
  if (pane) pane.dataset['dirty'] = '0';
}

/** true, wenn der übergebene Tab-Pane als „ungespeichert" markiert ist. */
export function isTabDirty(paneEl: HTMLElement): boolean {
  return paneEl.dataset['dirty'] === '1';
}

/**
 * Gemeinsamer Bestaetigungsdialog „Ungespeicherte Änderungen". Ruft `onDiscard()`, wenn der
 * Anwender „Verwerfen & wechseln" waehlt; bei „Hier bleiben" passiert nichts. Bewusst kein
 * `window.confirm` (Browser-Dialoge sind projektweit verboten).
 *
 * `what` benennt das Ziel im Text („Tab" / „Bereich"), damit der Satz an beiden Einsatzorten
 * stimmt.
 */
export function confirmDiscardChanges(onDiscard: () => void, what: 'Tab' | 'Bereich' = 'Tab'): void {
  const modal = openModal({
    title: 'Ungespeicherte Änderungen',
    icon: 'fa-triangle-exclamation',
    width: 460,
    body: `<p style="margin:0;line-height:1.5;">In diesem ${what} gibt es noch nicht gespeicherte Änderungen. Wenn du den ${what} wechselst, werden sie nicht übernommen.</p>`,
    footer: `<button type="button" class="v-button v-button--ghost" data-modal-cancel>Hier bleiben</button>
             <button type="button" class="v-button" data-discard style="background:#C0392B;border-color:transparent;color:#fff;">
               <span class="v-icon fa-regular fa-arrow-right-arrow-left"></span> Verwerfen &amp; wechseln
             </button>`,
    onMount: (rootEl) => {
      rootEl.querySelector<HTMLButtonElement>('[data-discard]')?.addEventListener('click', () => {
        modal.close();
        onDiscard();
      });
    },
  });
}
